import { render } from "./edit-pra_pelaksanaan_materi.vue?vue&type=template&id=121ff223"
import script from "./edit-pra_pelaksanaan_materi.vue?vue&type=script&lang=js"
export * from "./edit-pra_pelaksanaan_materi.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__